import React from 'react';
import './servicesBanner.css';
import { Link } from 'react-router-dom';

const ServiceBanner = ({ dataServiceBanner }) => {
    const isYellowBackground = dataServiceBanner.backgroundColor === '#FFCD00';

    return (
        <section
            className={`service-banner container ${isYellowBackground ? 'yellow-bg' : ''}`}
            style={{ backgroundColor: dataServiceBanner.backgroundColor }}
        >
            <div className="service-banner-content row">
                <div className="left-content col-md-6">
                    <h2>
                        {dataServiceBanner.titleLine1} <br />
                        <span>{dataServiceBanner.highlight}</span>
                    </h2>
                </div>
                <div className="right-content col-md-6">
                    <div
                        className="img-logo"
                        style={{
                            backgroundImage: isYellowBackground
                                ? "url('/assets/imgs/services/receipt-2-blk.png')" // Imagen para fondo amarillo
                                : "url('/assets/imgs/services/receipt-2.png')", // Imagen por defecto
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            width: "100px",
                            height: "100px",
                            marginBottom: "20px"
                        }}
                    ></div>
                    {/* <p>{dataServiceBanner.description}</p> */}
                    <Link to={dataServiceBanner.buttonLink} className="custom-service-btn btn-general">
                        {dataServiceBanner.buttonText}
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ServiceBanner;
